import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./reducers/userSlice";

const store = configureStore({
  reducer: {
    user: userReducer, // Define your reducer under the 'user' key
    // Add other reducers if needed
  },
  devTools: process.env.NODE_ENV !== "production", // Enable Redux DevTools Extension

  // Add middleware or enhancers as neededssss
});

export default store;
// import { configureStore } from "@reduxjs/toolkit";
// import { persistReducer, persistStore } from "redux-persist";
// import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

// import userReducer from "./reducers/userSlice";

// const persistConfig = {
//   key: "root",
//   storage,
// };

// const persistedReducer = persistReducer(persistConfig, userReducer);

// const store = configureStore({
//   reducer: {
//     user: persistedReducer,
//     // Add other reducers if needed
//   },
//   devTools: process.env.NODE_ENV !== "production",
// });

// export const persistor = persistStore(store);

// export default store;
